import { SVGIconProps } from './types'

export const RightIcon = (props: SVGIconProps) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.97353 7.96852L6.05049 10.0455C6.13702 10.132 6.18129 10.2408 6.1833 10.3718C6.1853 10.5028 6.14103 10.6136 6.05049 10.7041C5.95994 10.7947 5.85017 10.8399 5.72116 10.8399C5.59216 10.8399 5.48239 10.7947 5.39185 10.7041L2.58296 7.89521C2.52447 7.83672 2.4832 7.77502 2.45916 7.71012C2.43512 7.64522 2.4231 7.57511 2.4231 7.49979C2.4231 7.42447 2.43512 7.35436 2.45916 7.28946C2.4832 7.22455 2.52447 7.16286 2.58296 7.10437L5.39185 4.29548C5.47838 4.20893 5.58715 4.16466 5.71816 4.16266C5.84917 4.16065 5.95994 4.20492 6.05049 4.29548C6.14103 4.38602 6.1863 4.49579 6.1863 4.62479C6.1863 4.75379 6.14103 4.86356 6.05049 4.9541L3.97353 7.03105H11.6827C11.7388 7.03105 11.7848 7.01302 11.8209 6.97696C11.857 6.9409 11.875 6.89482 11.875 6.83873V4.99979C11.875 4.86678 11.9199 4.7554 12.0096 4.66566C12.0994 4.57592 12.2107 4.53105 12.3437 4.53105C12.4767 4.53105 12.5881 4.57592 12.6779 4.66566C12.7676 4.7554 12.8125 4.86678 12.8125 4.99979V6.83873C12.8125 7.15042 12.7021 7.41665 12.4813 7.6374C12.2606 7.85815 11.9944 7.96852 11.6827 7.96852H3.97353Z"
      fill="currentColor"
    />
  </svg>
)
